/*
 * Cybersource3ds
 */

jQuery(function($) {

	formHelper.addIPeerRule({

		iframe_custom_event_handler: function(payload) {
			switch (payload.event) {
				case "3dssavecardinalvars":

					// Store Cardinal variables within the CDE
					var ajaxData = {
						jwt:                      payload.jwt,
						cardinalSessionId:        payload.cardinalSessionId,
						cardinalBinProcessStatus: payload.cardinalBinProcessStatus
					};

					$.ajax({
						method: "POST",
						url: '/h/cybersource/AssignCardinalSessionVariables',
						dataType: 'JSON',
						data: ajaxData
					})
					.done(function( response ) {
						// Success - Process
						console.log("AssignCardinalSessionVariables Response: " + response.status);
					})
					.fail(function() {
						console.log("AssignCardinalSessionVariables - An unexpected error has occurred.");
					});
					break;
			}
		}
	});
});

var Cybersource3ds = function(options) {

		/*
		 * Variables accessible
		 * in the class
		 */
		var vars = {
			defaults: {
				xhrOptions: {
					cache:    false,
					dataType: 'json',
					type:     'POST'
				}
			}
		};

		/*
		 * Can access this.method
		 * inside other methods using
		 * root.method()
		 */
		var root = this;

		/*
		 * Constructor
		 */
		this.construct = function(options){
				jQuery.extend(vars, options);
		};

		/*
		 * Public method
		 * Can be called outside class
		 */
		this.performCyberSourceAuth = function(formHelperRequest, callBack) {

			var xhrOptions = jQuery.extend({}, vars.defaults.xhrOptions, {
				url: vars.ajaxURLs.performCyberSourceAuth,
				timeout: 0
			});

			jQuery.ajax(xhrOptions)
			.done(function(response) {

				console.log("performCyberSourceAuth - response status: " + response.status);
				console.log("performCyberSourceAuth - decision/reasonCode/authPath: " + response.data.decision + " / " + response.data.reasonCode + " / " + response.data.authPath);

				if (response.data.status === 'success') {

					if (response.data.decision === 'REJECT') {
						console.log("performCyberSourceAuth - acsURL: " + response.data.acsURL);

						Cardinal.complete({
							Status: "Success"
						})
						.then(function() {
							console.log("Cardinal.complete Success!!");

							// Configure ===========================
							Cardinal.configure ({
								logging: {
									level: "on",
									debug: 'verbose'
								},
								payment: {
									view: 'modal',
									framework: 'cardinal',
									displayLoading: true
								}
							});

							// Setup ===========================

							console.log("performCyberSourceAuth JWT value: " + response.data.jwt);
							Cardinal.setup('init', { "jwt" : response.data.jwt });

							var continueObj = {
								"AcsUrl": response.data.acsURL,
								"Payload": response.data.paReq
							};

							var orderObj = {
								"OrderDetails":{
									"TransactionId":    response.data.transactionID,
									"OrderNumber":      response.data.orderNumber,
									"Amount":           response.data.orderAmount,
									"CurrencyCode":     response.data.currencyCode,
									"OrderDescription": response.data.orderDesc,
									"OrderChannel":     response.data.orderChannel
								}
							};
							var cardinalContinueRequest = JSON.stringify(continueObj) + ',' + JSON.stringify(orderObj);
							console.log("cardinalContinueRequest: " + cardinalContinueRequest);

							Cardinal.continue('cca', continueObj, orderObj);

							Cardinal.on("payments.validated", function (cdata, jwt) {

								// We only want this callback to execute once per this event.  Therefore, we can now unsubscribe this listener.
								Cardinal.off('payments.validated');

								console.log("payments.validated - ErrorNum / ErrorDesc Response: " + cdata.ErrorNumber + " / " + cdata.ErrorDescription);
								console.log("payments.validated - jwt response: " + jwt);

								var paymentsValidatedFlag = '';

								if (cdata.ErrorNumber === 0) {
									paymentsValidatedFlag = 'success';
								}

								// Store / Save Cardinal JWT response
								var ajaxData = {
									transactionID:   response.data.transactionID,
									cardinalRequest: cardinalContinueRequest,
									jwtResponse:     jwt
								};

								xhrOptions = jQuery.extend({}, vars.defaults.xhrOptions, {
									url: vars.ajaxURLs.storeCardinalJwtResponse,
									data: ajaxData
								});

								jQuery.ajax(xhrOptions)
								.done(function( response ) {
									console.log("AjaxStoreCardinalJwtResponse - " + response.status);
								})
								.fail(function() {
									console.log("AjaxStoreCardinalJwtResponse - An unexpected error has occurred.");
								});

								if (response.data.reasonCode === '475') {
									// Enrolled Cards Proceed with Validation
									// CyberSource Payer Authentication Validation Request

									ajaxData = {
										transactionID: response.data.transactionID
									};

									xhrOptions = jQuery.extend({}, vars.defaults.xhrOptions, {
										url: vars.ajaxURLs.cyberSourcePayerAuthValidationRequest,
										data: ajaxData
									});

									jQuery.ajax(xhrOptions)
									.done(function( response ) {
										console.log("AjaxCyberSourcePayerAuthValidationRequest - decision/reasonCode: " + response.data.decision + " / " + response.data.reasonCode);

										paymentsValidatedFlag = 'reject';
										if (response.data.reasonCode === "100") {
											paymentsValidatedFlag = 'success';
										}
										callBack(formHelperRequest, paymentDecision(cdata, paymentsValidatedFlag));
									})
									.fail(function() {
										console.log("AjaxCyberSourcePayerAuthValidationRequest - An unexpected error has occurred.");
									});
								}
								else {
									callBack(formHelperRequest, paymentDecision(cdata, paymentsValidatedFlag));
								}
							});
						})
						.catch(function(error) {
							// Triggers if any error is thrown.
							// This would include any errors encountered in your .then callBack, if you're not properly catching errors.
							console.log("Cardinal.complete ERROR!!");
						})
					}
					else if (response.data.decision === 'ACCEPT' && response.data.reasonCode === '100') {
						callBack(formHelperRequest, 'VALIDATION_SUCCESS');
					}
					else if (jQuery.inArray(response.data.reasonCode, ['150','151','152']) >= 0) {
						// Timout and General system failure
						callBack(formHelperRequest, 'SERVICE_TIME_OUT');
					}
				}
				else {
					callBack(formHelperRequest, 'DATA_RESPONSE_ERROR');
				}
			})
			.fail(function() {
				console.log("performCyberSourceAuth - An unexpected error has occurred.");
			});
		}

		/*
		 * Private methods
		 */
		var paymentDecision = function(cdata, paymentsValidatedFlag) {
			if (paymentsValidatedFlag === 'success') {
					console.log("payments.validated - Success: " + cdata.ErrorDescription);
					return 'VALIDATION_SUCCESS';
			}
			else {
				console.log("payments.validated - Error: " + cdata.ErrorNumber + " / " + cdata.ErrorDescription);
				return 'VALIDATION_FAILURE';
			}
		}


		/*
		 * Pass options when class instantiated
		 */
		this.construct(options);

};
